import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ControlResumidoService } from 'src/app/services/control-resumido.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { DeclaracionComponent } from './declaracion/declaracion.component';
import { ControlResumidoComponent, HeaderParams } from './control-resumido/control-resumido.component';
import { ToastService } from 'ng-uikit-pro-standard';
import { DepositoEfectivoService } from 'src/app/services/deposito-efectivo.service';

@Component({
  selector: 'app-deposito-efectivo',
  templateUrl: './deposito-efectivo.component.html',
  styleUrls: ['./deposito-efectivo.component.scss'],
  providers: [SecurityService]
})
export class DepositoEfectivoComponent implements OnInit {

  // Modales
  @ViewChild(DeclaracionComponent, { static: true }) declaracionComponent: DeclaracionComponent
  @ViewChild(ControlResumidoComponent, { static: true }) controlResumidoComponent: ControlResumidoComponent

  // Data & Tmp
  private rutEmpresa: number
  private sucursalEmpresa: number
  headerParams: HeaderParams = null
  paginationContext: PaginationContext = new PaginationContext()
  listaResumen: Array<any> = null

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private clog: ConsoleService,
    private controlResumidoService: ControlResumidoService,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private depositoEfectivoService: DepositoEfectivoService
  ) {
    this.log = this.clog.log('DEPOSITO-EFECTIVO')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.sucursalEmpresa = Number(this.accesolocalstorage.getSucursalCodigo())

    this.paginationContext.RecordsByPage = 5
  }

  onSearch(data: HeaderParams) {
    this.log('Buscar')
    // this.controlResumidoComponent.loadData(data)
    this.headerParams = data
    this.buscar(1)
  }

  buscar(pageNumber) {
    this.listaResumen = null
    this.paginationContext.CurrentPage = pageNumber
    const { fecha_desde, fecha_hasta } = this.headerParams
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalEmpresa,
        fecha_desde,
        fecha_hasta
      },
      cantidadRegistrosPorPagina: this.paginationContext.RecordsByPage,
      paginaActual: this.paginationContext.CurrentPage
    }

    this.controlResumidoService.obtenerControlResumenSegunFiltro(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
      this.paginationContext.RecordsCount = totalRegistros
      this.paginationContext.CurrentPage = paginaActual
      this.paginationContext.PagesCount = totalPaginas
      registros.map((item, index) => {
        item.seleccion = false
        item.index = index
        delete item.__typename
      })
      this.listaResumen = registros
      // this.listaResumen.map((item, index) => {
      //   item.seleccion = false
      //   item.index = index
      // })
    })
  }

  onPageChange(context: PaginationContext) {
    this.buscar(context.RequestedPage)
  }


  Guardar() {
    if (!this.controlResumidoComponent.validate()) {
      this.toastrService.warning('Complete los datos solicitados')
      return
    }
    const controlResumido: any = this.controlResumidoComponent.getControlResumido()
    const totalDeclaracion = this.declaracionComponent.getTotal()

    controlResumido.entidad.monto = totalDeclaracion

    const inputParms = controlResumido
    this.log('inputParms', JSON.stringify(inputParms))

    this.depositoEfectivoService.guardarDepositoEfectivo(inputParms, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación exitosa')
      this.controlResumidoComponent.clear()
      this.declaracionComponent.clear()
      this.buscar(1)
    })
  }

}
